import React, { useState, useEffect, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
    setUserActions,
    setTheInternalDepartmentCreatedActions,
    setTheInternalDepartmentRetrieveActions,
    getTheUDSQuestionsData,
    setTheInternalDepartmentEditActions,
    setRegionActions,
    getTheLevelUsersListData
} from "../../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import LImages from "../../../../Assets/AppComponent/Union (15).svg"
import closebtnimg from "../../../../Assets/AppComponent/Group 427320024.svg"
import dropdownimg from "../../../../Assets/AppComponent/Vector (22).svg"
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

const DepartmentCrud = (props) => {
    const {
        currentPage,
        setShow,
        show,
        EditId,
        getsearch
    } = props;

    const state = useSelector((state) => state);
    const initialStateSearch = {
        categorySearch: "",
        usersearh: "",
        regionSearch: "",
        stateSearch: ''
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);
    const dispatch = useDispatch();

    const createnewuser = {
        department_name: "",
        description: "",
        l1_user: [],
        l2_user: [],
        l3_user: [],

        l1_time_type: "",
        l2_time_type: "",
        l3_time_type: "",

        l1_user_TAT: "",
        l2_user_TAT: "",
        l3_user_TAT: "",
        issue_ids: [],
        incharge_ids: [],
        region_id: "",
        department_id: EditId
    };

    const [data, setData] = useState(createnewuser);


    const [categoryErr, setcategoryerr] = useState([]);


    const [clientNameEr, setClientNaaErr] = useState("");

    const [Categorydata, setcategoryData] = useState([]);
    const [categoryvalue, setcategoryvalues] = useState([])
    const [Departmentactive, setDepartmentActive] = useState(true)



    const handleRadioChangeActives = () => {
        setDepartmentActive(prev => !prev);

    };


    useEffect(() => {
        if (data.l3_user.length > 0) {
            setData({
                ...data,
                incharge_ids: data.l3_user
            })
        }
    }, [data.l3_user])


    const HandleCategoryMuliti = (e) => {
        let categoryids = []
        if (e != null) {
            setcategoryvalues(e);

            e.map((item) => {
                categoryids.push(item.value)
            })
            setcategoryerr("");
            setData({
                ...data,
                issue_ids: categoryids
            })
        }
    }
    const handleInputcategory = (e) => {
        setSearched({
            ...SearchedVal,
            categorySearch: e
        })
    }



    useEffect(() => {
        if (EditId != "" && EditId != undefined) {
            const payload = {
                EditId: EditId

            }
            dispatch(setTheInternalDepartmentRetrieveActions(payload))
        }
    }, [])




    useEffect(() => {
        if (EditId != "" && EditId != undefined) {
            if (state.InternalDepartmentsRetrieveName.InternalDepartmentsRetrievedatas) {
                let issuesIds = [];
                let IssueObjects = [];
                state.InternalDepartmentsRetrieveName.InternalDepartmentsRetrievedatas.issue_ids != undefined && state.InternalDepartmentsRetrieveName.InternalDepartmentsRetrievedatas.issue_ids.length > 0 && state.InternalDepartmentsRetrieveName.InternalDepartmentsRetrievedatas.issue_ids.map((item) => {
                    issuesIds.push(item.id)
                    IssueObjects.push({ value: item.id, label: item.name });

                })
                setData({
                    ...data,
                    department_name: state.InternalDepartmentsRetrieveName.InternalDepartmentsRetrievedatas.department_name,
                    description: state.InternalDepartmentsRetrieveName.InternalDepartmentsRetrievedatas.description,
                    issue_ids: issuesIds,
                })
                setcategoryvalues(IssueObjects)

                setDepartmentActive(state.InternalDepartmentsRetrieveName.InternalDepartmentsRetrievedatas.is_active)


            }
        }

    }, [state.InternalDepartmentsRetrieveName.InternalDepartmentsRetrievedatas])




    useEffect(() => {
        const payload = {
            search: SearchedVal.categorySearch,
            page_size: 20,
            page: 1,
        };
        dispatch(getTheUDSQuestionsData(payload));
    }, [SearchedVal.categorySearch]);



    useEffect(() => {
        if (state.UDSQuetionsDatas.UDSCateQuestionsDatas !== undefined) {
            let ObjectArrayFormager = [];
            state.UDSQuetionsDatas.UDSCateQuestionsDatas.forEach((element) => {
                ObjectArrayFormager.push({
                    value: element.id,
                    label: element.name,
                });

            });


            setcategoryData(ObjectArrayFormager);
        }
    }, [state.UDSQuetionsDatas.UDSCateQuestionsDatas, SearchedVal.categorySearch]);







    const HandleChanges = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value,
        });
    };







    const HandleClick = (e) => {
        var a = 0;

        if (data.department_name == "") {
            setClientNaaErr("*Department Name is required");
            a = 1;
        }
        if (data.issue_ids.length == 0) {
            setcategoryerr("*Category is required");
            a = 1;
        }



        if (EditId == "") {
            if (a == 0) {
                const payload = {
                    data: {
                        department_name: data.department_name,
                        description: data.description,
                        issue_ids: data.issue_ids,
                        is_active: Departmentactive,
                    },
                    currentPage: currentPage,
                    search: getsearch
                }
                dispatch(setTheInternalDepartmentCreatedActions(payload, setShow(false)))
            }
        }
        else {
            if (a == 0) {

                const payload = {
                    data: {
                        department_name: data.department_name,
                        description: data.description,
                        issue_ids: data.issue_ids,
                        is_active: Departmentactive,


                    },
                    currentPage: currentPage,
                    search: getsearch,
                    EditId: EditId
                }
                dispatch(setTheInternalDepartmentEditActions(payload, setShow(false)))

            }
        }
    }

    const handleClosepop = (e) => {
        setShow(false)
    }


    const HandleSubmits = (e) => {
        e.preventDefault();
    };
    return (
        <>
            <div className="RoleCreatePopup">
                <div className="BeforePopUp">
                    <div className="RolePopups" style={{ width: "30%" }}>
                        <div className="asds">
                            <div className="ModalHeader">
                                <div>
                                    <span>Department</span>
                                </div>

                                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                                    <CloseOutlinedIcon />
                                </div>

                            </div>
                            <form class="row g-3 form-fields-wrapper" onSubmit={(e) => {
                                e.preventDefault();
                                HandleSubmits(e);
                            }}
                            >
                                <div className="col-12 field-div"
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                    }}
                                >
                                    <label
                                        for="validationCustom01"
                                        class="form-label"
                                    >

                                        <div
                                            className="col-12 LeaveButtonVeirif"
                                            style={{
                                                width: "100%"
                                            }}
                                        >
                                            <div className="InnerChoicesDATA"
                                                style={{
                                                    width: "100%"
                                                }}
                                            >
                                                <label className="BranchButton">
                                                    <input
                                                        className="form-check-input custom-radioRegurlarization"
                                                        type="checkbox"
                                                        checked={Departmentactive}
                                                        onChange={handleRadioChangeActives}
                                                    />
                                                    <span>Active</span>
                                                </label>
                                            </div>
                                        </div>
                                    </label>
                                </div>

                                <div className="col-12  mb-1 field-div">
                                    <label
                                        for="validationCustom01"
                                        class="form-label"
                                    >
                                        Department Name
                                        <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="validationCustom01"
                                        autocomplete="off"
                                        name="department_name"
                                        value={data.department_name}
                                        onChange={(e) => {
                                            HandleChanges(e);
                                            setClientNaaErr("")
                                        }}
                                    />
                                    <p className="Error"> {clientNameEr} </p>
                                </div>
                                <div className="col-12 mb-3 field-div">
                                    <label
                                        for="validationCustom01"
                                        class="form-label"
                                    >
                                        Description
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="validationCustom01"
                                        autocomplete="off"
                                        name="description"
                                        value={data.description}
                                        onChange={(e) => {
                                            HandleChanges(e);
                                        }}
                                    />
                                </div>
                                <div className="col-12 mb-1 field-div">
                                    <label
                                        for="validationCustom01"
                                        class="form-label"
                                    >
                                        Category
                                        <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                        value={categoryvalue}
                                        options={Categorydata}
                                        isMulti
                                        onChange={(e) => {
                                            HandleCategoryMuliti(e)
                                        }}
                                        onInputChange={(e) => { handleInputcategory(e) }}
                                    />

                                    <p className="Error"> {categoryErr} </p>
                                </div>








                                <div className="RoleButton"
                                    style={{
                                        display: "flex",
                                        gap: "15px",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        padding: "0px 14px"
                                    }}

                                >


                                    {/* <button
                                        class="btn Createbutton"
                                        onClick={(e) => {
                                            handleClosepop(e);
                                        }}
                                    >
                                        Cancel
                                    </button> */}


                                    <button
                                        class="btn  Createbutton"
                                        type="submit"
                                        onClick={(e) => {
                                            HandleClick(e);
                                        }}
                                    >
                                        {EditId == undefined || EditId == ""
                                            ? "Submit"
                                            : "Update"}
                                    </button>

                                </div>
                            </form>



                        </div>
                    </div>
                </div>
            </div>



            <>

            </>
        </>
    )
}

export default DepartmentCrud

